import { FC } from 'react'
import { useProfile } from '../../hooks/use-profile'
import { SettingsProfileInfoFormCustomerMode } from './settings-profile-info-form-customer-mode'
import { SettingsProfileInfoFormPersonalMode } from './settings-profile-info-form-personal-mode'
import type { SettingsProfileInfoFormProps } from './settings-profile-info-form.interface'

export const SettingsProfileInfoForm: FC<SettingsProfileInfoFormProps> = ({
  profileInfo,
  preferences,
  setIsProfileInfoEditing,
  onFormValuesChange,
  onCancel,
  hideSubmitButton,
  onDirtyChange,
}) => {
  const { isLoading, data } = useProfile()

  if (isLoading) return null

  return data.usage_mode === 'personal' ? (
    <SettingsProfileInfoFormPersonalMode
      profileInfo={profileInfo}
      preferences={preferences}
      setIsProfileInfoEditing={setIsProfileInfoEditing}
      onFormValuesChange={onFormValuesChange}
      onCancel={onCancel}
    />
  ) : (
    <SettingsProfileInfoFormCustomerMode
      profileInfo={profileInfo}
      preferences={preferences}
      setIsProfileInfoEditing={setIsProfileInfoEditing}
      onFormValuesChange={onFormValuesChange}
      onCancel={onCancel}
      hideSubmitButton={hideSubmitButton}
      onDirtyChange={onDirtyChange}
    />
  )
}
